var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrowsChange"},[_c('span',{class:{'top': true, 'top-on': _vm.num === 0}}),_c('span',{class:{'bottom': true, 'bottom-on': _vm.num === 1}})])}
var staticRenderFns = []

export { render, staticRenderFns }